document.addEventListener('DOMContentLoaded', function () {
    // Add a small delay to ensure the rating snippets are fully loaded
    setTimeout(function () {
        const ratingElements = document.querySelectorAll('.product-info__title-wrapper .ruk-rating-snippet-count');
        ratingElements.forEach(function (element) {
            if (element) {
                const currentText = element.textContent;
                const match = currentText.match(/\((\d+)\s+Reviews\)/i);
                if (match && match[1]) {
                    element.textContent = `(${match[1]})`;
                }
            }
        });
    }, 100);
});

document.addEventListener('DOMContentLoaded', function () {
    const reviewElement = document.querySelector('.usage-pack-section__main-review');
    if (reviewElement) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(function () {
                            reviewElement.style.opacity = '1';
                            reviewElement.style.transition = 'opacity 0.5s ease-in-out';
                        }, 1000);
                        observer.unobserve(reviewElement);
                    }
                });
            },
            {
                threshold: 0.1,
            },
        );
        observer.observe(reviewElement);
    }
});

// Preise korrekt aus dem aktiven Markt-Katalog formatieren (keine Umrechnung, nur Format)
function bdGeneralFormatMoney(cents) {
  var settings = (window.themeVariables && window.themeVariables.settings) || {};
  var amount = (cents / 100).toFixed(2);
  var sep = settings.currencyDecimalSeparator || ',';
  if (sep !== '.') {
    amount = amount.replace('.', sep);
  }
  var symbol = settings.currencySymbol || '€';
  var position = settings.currencyPosition || 'suffix';
  return position === 'prefix' ? (symbol + ' ' + amount) : (amount + ' ' + symbol);
}

document.addEventListener('variant:change', function (event) {
    try {
        // Update delivery text
        const deliveryTextElement = document.getElementById('delivery-text');
        if (deliveryTextElement) {
            const variantMetafields = document.querySelector('script[data-variant-metafields]')?.textContent || '';
            if (variantMetafields) {
                deliveryTextElement.textContent = variantMetafields;
            }
        }

        // Update prices
        const variantData = document.querySelector('script[data-variant]')?.textContent;
        if (variantData) {
            const variant = JSON.parse(variantData);

            // Update one-time purchase price
            const priceAmount = document.querySelector('.selling-plan-option:not(.subscription-option) .price-amount');
            if (priceAmount) {
                priceAmount.textContent = bdGeneralFormatMoney(variant.price);
            }

            // Update one-time purchase unit price
            const priceUnit = document.querySelector('.selling-plan-option:not(.subscription-option) .price-unit');
            if (priceUnit && variant.unit_price) {
                priceUnit.textContent = `(${bdGeneralFormatMoney(variant.unit_price)}/ pro l)`;
            }

            // If there's a subscription option, update its prices too
            const subscriptionPriceAmount = document.querySelector('.subscription-option .price-amount');
            const subscriptionOriginalPrice = document.querySelector('.subscription-option .original-price');
            const subscriptionPriceUnit = document.querySelector('.subscription-option .price-unit');

            if (subscriptionPriceAmount && subscriptionOriginalPrice && subscriptionPriceUnit) {
                const discountText = document.querySelector('.subscription-option .selling-plan-title')?.textContent || '';
                const discountMatch = discountText.match(/\d+/);
                const discountPercentage = discountMatch ? parseInt(discountMatch[0]) : 0;

                const originalPriceCents = variant.price;
                const discountedPriceCents = Math.round(originalPriceCents * (1 - discountPercentage / 100));

                subscriptionOriginalPrice.textContent = bdGeneralFormatMoney(originalPriceCents);
                subscriptionPriceAmount.textContent = bdGeneralFormatMoney(discountedPriceCents);

                if (variant.unit_price) {
                    const originalUnitPriceCents = variant.unit_price;
                    const discountedUnitPriceCents = Math.round(originalUnitPriceCents * (1 - discountPercentage / 100));
                    subscriptionPriceUnit.textContent = `(${bdGeneralFormatMoney(discountedUnitPriceCents)}/ pro l)`;
                }
            }
        }
    } catch (error) {
        console.error('Error updating variant information:', error);
    }
});